import {Box, Typography} from '@material-ui/core'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {SplitLoadOrderIntakePayload} from '../../BulkCement/containers/SplitLoad/buildSplitLoadPayload'

interface OrderAdditionalInfoProps {
  payload: SplitLoadOrderIntakePayload
  firstLineItem: SplitLoadOrderIntakePayload['salesOrderLineItems'][0]
}

export const OrderAdditionalInfo: React.FC<OrderAdditionalInfoProps> = ({
  payload,
  firstLineItem
}) => {
  const {t} = useTranslation()

  return (
    <>
      {/* Customer Reference / PO Number */}
      <Box mb={1}>
        <Typography variant="body2" color="secondary">
          {t('orderIntake.customerReference')}
        </Typography>
        <Typography variant="body2" color="textPrimary">
          {payload.customerReference || '-'}
        </Typography>
      </Box>

      {/* Hauler Information (if available) */}
      {payload.haulerInfo && (payload.haulerInfo.companyName || payload.haulerInfo.driverName) && (
        <Box mb={1}>
          <Typography variant="body2" color="secondary">
            {t('orderIntake.haulerInfo')}
          </Typography>
          {payload.haulerInfo.companyName && (
            <Typography variant="body2" color="textPrimary">
              {t('orderIntake.company')}: {payload.haulerInfo.companyName}
            </Typography>
          )}
          {payload.haulerInfo.driverName && (
            <Typography variant="body2" color="textPrimary">
              {t('orderIntake.driver')}: {payload.haulerInfo.driverName}
            </Typography>
          )}
          {payload.haulerInfo.licensePlate && (
            <Typography variant="body2" color="textPrimary">
              {t('orderIntake.licensePlate')}: {payload.haulerInfo.licensePlate}
            </Typography>
          )}
        </Box>
      )}

      {/* Driver Instructions (if available) */}
      {payload.additionalDriverInfo?.driverInstructions && (
        <Box>
          <Typography variant="body2" color="secondary">
            {t('orderIntake.driverInstructions')}
          </Typography>
          <Typography variant="body2" color="textPrimary">
            {payload.additionalDriverInfo.driverInstructions}
          </Typography>
        </Box>
      )}
    </>
  )
}
